import TodayGrassTile from './TodayGrassTile';

import { GrassWidgetProps } from '@/shared/types';
import {
  GrassBodyContainer,
  GrassBody as GrassBodyFeature,
} from '@/features/Landing';

const GrassBody = ({ grassListPromise }: GrassWidgetProps) => {
  return (
    <GrassBodyContainer>
      <GrassBodyFeature
        grassListPromise={grassListPromise}
        todayGrassTileComponent={<TodayGrassTile key="today-grass-tile" />}
      />
    </GrassBodyContainer>
  );
};

export default GrassBody;
